import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Text from '../Text/Text';

import { useAuthState } from 'contexts/auth-context';
import { getInitials, colorList } from 'utils/common';

import classes from './Avatar.module.scss';

const Avatar = ({
  initials = 'NA',
  initialsColor,
  image,
  className,
  ...other
}) => {
  const { auth } = useAuthState();
  const { user } = auth;

  const isInitialsColor = initCol =>
    initCol && initCol !== '-' && initCol !== 'NA';
  const userInitials = getInitials(user.firstName, user.lastName);

  return (
    <figure
      style={{
        backgroundColor:
          userInitials === initials
            ? isInitialsColor(user.initialsColor)
              ? user.initialsColor
              : colorList[
                  (userInitials.charCodeAt(0) + userInitials.charCodeAt(1)
                    ? userInitials.charCodeAt(1)
                    : 0) %
                    (colorList.length - 1)
                ]
            : isInitialsColor(initialsColor)
            ? initialsColor
            : colorList[
                (initials.charCodeAt(0) + initials.charCodeAt(1)
                  ? initials.charCodeAt(1)
                  : 0) %
                  (colorList.length - 1)
              ]
      }}
      className={cn(classes.base, className)}
      {...other}
    >
      {image && image !== '-' && image !== 'NA' ? (
        <img src={image} alt="avatar" width="100%" height="100%" />
      ) : (
        <Text className={classes.text} size={2}>
          {initials}
        </Text>
      )}
    </figure>
  );
};

Avatar.propTypes = {
  initials: PropTypes.string,
  initialsColor: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string
};

export default Avatar;
